// core version + navigation, pagination modules:
import Swiper from 'swiper/bundle'

// import Swiper and modules styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

// init Swiper:
const swiper = new Swiper('.swiper-11', {
	pagination: {
		el: '.swiper-pagination-custom',
		bulletClass: 'duration-300',
		bulletActiveClass: 'scale-125',
		renderBullet: function (index, className) {
			return (
				'<img src="/wp-content/themes/MinisterstwoReklamy/images/icons/bullet-slider.svg" class="' +
				className +
				' dark:invert">'
			)
		}
	},

	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next-custom-11',
		prevEl: '.swiper-button-prev-custom-11'
	},

	breakpoints: {
		360: {
			slidesPerView: 1,
			spaceBetween: 20
		},

		768: {
			slidesPerView: 2,
			spaceBetween: 20
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 20
		}
	}
})
